/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { useNavEnrollCtaSlot } from 'bundles/unified-common/providers/NavEnrollCtaProvider';

const styles = {
  slot: css`
    display: flex;
    align-items: center;
  `,
};

/**
 * Empty portal target for the XDP Enroll CTA. Renders nothing until a page module portals into it.
 */
const MobileWebEnrollGridItem = () => {
  const { setSlot } = useNavEnrollCtaSlot();

  return <div ref={setSlot} css={styles.slot} data-testid="mobile-web-enroll-slot" />;
};

export default MobileWebEnrollGridItem;
